'use client';
import { ComponentProps, useState } from 'react';
import cn from 'classnames';
import SXMLink from '@/shared-components/SXMLink';
import { ChannelCard, ChannelCardProps } from '@/components/molecules/ChannelCard';
import styles from './channelCardGroup.module.scss';
import TitleAndLink from '@/ui-components/atoms/TitleAndLink/TitleAndLink';

export interface ChannelCardGroupProps {
    headline?: string;
    linkUrl?: string;
    linkAria?: string;
    linkText?: string;
    channels: ChannelCardProps[];
}

type TitleAndLinkProps = ComponentProps<typeof TitleAndLink>;

export function ChannelCardGroup({ channels, headline, linkUrl, linkAria, linkText }: ChannelCardGroupProps) {
    const [activeItem, setActiveItem] = useState<number>();
    const headlineProps: TitleAndLinkProps = {
        text: headline,
        link: {
            children: linkText,
            href: linkUrl,
            ['aria-label']: linkAria,
        },
    };

    return (
        <>
            {headline && (
                <div className={styles.headline}>
                    <TitleAndLink {...headlineProps} />
                </div>
            )}

            <div className={styles.group}>
                {channels.map((args, i) => (
                    <div className={styles.cardWrapper} key={i}>
                        <ChannelCard
                            {...args}
                            onKebabClick={() => setActiveItem(i)}
                            index={i}
                            activeItem={activeItem}
                            wrapperClass={cn({
                                [styles.lastCard]: i + 1 === channels?.length,
                            })}
                        ></ChannelCard>
                    </div>
                ))}
            </div>

            {linkUrl && (
                <SXMLink href={linkUrl} aria-label={linkAria} className={styles.mobileLink}>
                    {linkText}
                </SXMLink>
            )}
        </>
    );
}
